const BASE_URL = process.env.REACT_APP_API_URL;
const B2B_URL = process.env.REACT_APP_B2B_URL;
export { B2B_URL, BASE_URL };
